// extracted by mini-css-extract-plugin
module.exports = {"post":"post_post__la1GM"};